import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import MetricScoreCardItem from './MetricScoreCardItem';
import { MetricProps } from '../../../../../../graphs/AirQualityGraph';
import Colors from '../../../../../../constants/Colors';
import ScrollViewStyled from '../../../../../../components/ScrollViewStyled';

interface MetricScoreSectionProps {
  scores: number[],
  scoresCompared: number[],
  overallScore: number,
  overallScoreCompared?: number
  showComparison: boolean,
  metrics: MetricProps[],
}

const MetricScoreSection = ({
  scores, scoresCompared, overallScore, overallScoreCompared, showComparison, metrics,
}: MetricScoreSectionProps) => <View style={styles.scoreCard}>
    <View style={styles.scoreCardTopSection}>
      <View style={styles.row}>
        <Text style={styles.scoreValue}>{overallScore ?? '-'}</Text>
        {showComparison && <Text style={[styles.scoreValue, styles.scoreValueCompared]}>
          {overallScoreCompared ?? '-'}
        </Text>}
      </View>
    </View>
    <Text style={styles.scoreCardTitle}>{'Average happy score per metric'}</Text>
    <ScrollViewStyled
      style={styles.list}
      contentContainerStyle={styles.scoreCardItemsSection}
    >
      {metrics?.map((metric: MetricProps, index: number) => <MetricScoreCardItem
        key={`${metric.title}_score_card_item`}
        {...{ showComparison, metric }}
        score={scores[index]}
        scoreCompared={scoresCompared[index]}
      />)}
    </ScrollViewStyled>
  </View>;

const styles = StyleSheet.create({
  scoreCard: {
    width: 344,
    borderRadius: 16,
    padding: 24,
    paddingBottom: 0,
    marginEnd: 10,
    borderWidth: 1,
    backgroundColor: Colors.light.hereworksWhite300,
    borderColor: Colors.light.hereworksWhite500,
  },
  scoreCardTopSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: 8,
    borderBottomWidth: 1,
    marginBottom: 24,
    borderBottomColor: Colors.light.hereworksBlue200,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  scoreValue: {
    fontSize: 48,
    lineHeight: 46,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksEmeraldGreen,
    marginEnd: 12,
  },
  scoreValueCompared: {
    color: Colors.light.hereworksYellow600,
  },
  scoreCardTitle: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
    marginBottom: 8,
  },
  scoreCardItemsSection: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingBottom: 24,
  },
  list: {
    paddingEnd: 8,
  },
});

export default MetricScoreSection;
